import React, {useState} from 'react';
import {DataContainerStyled} from "../../styled/Resume";
import {useTheme} from "../UI/Theme/ThemeContext";
import DataHeader from "./DataHeader";
import CustomizeStep from "./Steps/CustomizeStep";
import {IoMdArrowRoundBack, IoMdArrowRoundForward,} from "react-icons/io";




const DataContainer = (props) => {
    const {
        bubblePoints,
        DragDropHandleDrop,
        DragDropRef,
        DragDropFileError,
        DragDropFile,
        DragDropHandleUploadFile,
        clearManualUpload,
        optimizeBasicInfo,
        optimizeHandleInputChange,
        optimizeJobConnectType,
        optimizeJobTypesArray,
        optimizeHandleJobConnectType,
        optimizeSetAdditionalInfo,
        optimizeAdditionalInfo,
        handleFileResumeOptimize,
        onSubmitCreate,
        addlInfoImagePreviews,
        addlInfoFileInputRef,
        triggerAddlInfoSelect,
        handleAddlInfoFileSelect,
        removeSingleAddlInfoImage,
        basicLinkInfo,
        basicHandleAddLinks,
        basicHandleDeleteLinks,
        basicHandleLinkChange,
        eduArray,
        handleEduExpChange,
        handleDeleteEduInfo,
        handleAddEduInfo,
        workExpArray,
        handleWorkExpChange,
        handleDeleteExp,
        handleAddExp,
        skills,
        handleSkillChange,
        handleDeleteSkill,
        handleAddSkill,
        awardArray,
        handleAwardChange,
        handleDeleteAward,
        handleAddAward,
        publications,
        handlePubChange,
        handleDeletePublication,
        handleAddPublication,
        languages,
        handleLangChange,
        languageStore,
        langLevelsArray,
        handleDeleteLang,
        handleAddLang,
        interests,
        setInterestsArray,
        handleInterestChange,
        handleDeleteInterests,
        handleAddInterests,
        basicInfoForward,
        eduInfoForwardOrBackward,
        workExpForwardOrBackward,
        skillsForwardOrBackward,
        certsForwardOrBackward,
        pubForwardOrBackward,
        langForwardOrBackward,
        interestsBackward,
        existingResumes,
        existingResumeSelectedIndex,
        onExistingResumeSelect,
        onExistingResumePreview,
        storedResumeSelected,
        selectedStoredResumeName,
    } = props
    const [activeStep, setActiveStep] = useState(1);

    const totalSteps = 3; // 🔧 set this to however many steps you want

    const handlePrevious = () => {
        setActiveStep((prev) => (prev > 1 ? prev - 1 : prev));
    };

    const handleForward = () => {
        setActiveStep((prev) => (prev < totalSteps ? prev + 1 : prev));
    };
    const {themeName} = useTheme();
    return (
        <div className="content">
            <DataContainerStyled theme={themeName}>
                <DataHeader activeStep={activeStep}/>
                <div className="controls">
                    {activeStep > 1 && <span className="icon" onClick={handlePrevious}>
                        <IoMdArrowRoundBack />
                    </span>}
                    {activeStep === 2  && <span className="icon" onClick={handleForward}>
                        <IoMdArrowRoundForward />
                    </span>}
                </div>

                {activeStep === 1 && (
                    <CustomizeStep
                        bubblePoints={bubblePoints}
                        setActiveStep={setActiveStep}
                        DragDropHandleDrop={DragDropHandleDrop}
                        DragDropRef={DragDropRef}
                        DragDropFileError={DragDropFileError}
                        DragDropFile={DragDropFile}
                        DragDropHandleUploadFile={DragDropHandleUploadFile}
                        clearManualUpload={clearManualUpload}
                        optimizeBasicInfo={optimizeBasicInfo}
                        optimizeHandleInputChange={optimizeHandleInputChange}
                        optimizeJobConnectType={optimizeJobConnectType}
                        optimizeJobTypesArray={optimizeJobTypesArray}
                        optimizeHandleJobConnectType={optimizeHandleJobConnectType}
                        optimizeSetAdditionalInfo={optimizeSetAdditionalInfo}
                        optimizeAdditionalInfo={optimizeAdditionalInfo}
                        handleFileResumeOptimize={handleFileResumeOptimize}
                        onSubmitCreate={onSubmitCreate}
                        addlInfoImagePreviews={addlInfoImagePreviews}
                        addlInfoFileInputRef={addlInfoFileInputRef}
                        triggerAddlInfoSelect={triggerAddlInfoSelect}
                        handleAddlInfoFileSelect={handleAddlInfoFileSelect}
                        removeSingleAddlInfoImage={removeSingleAddlInfoImage}
                        basicLinkInfo={basicLinkInfo}
                        basicHandleAddLinks={basicHandleAddLinks}
                        basicHandleDeleteLinks={basicHandleDeleteLinks}
                        basicHandleLinkChange={basicHandleLinkChange}
                        eduArray={eduArray}
                        handleEduExpChange={handleEduExpChange}
                        handleDeleteEduInfo={handleDeleteEduInfo}
                        handleAddEduInfo={handleAddEduInfo}
                        workExpArray={workExpArray}
                        handleWorkExpChange={handleWorkExpChange}
                        handleDeleteExp={handleDeleteExp}
                        handleAddExp={handleAddExp}
                        skills={skills}
                        handleSkillChange={handleSkillChange}
                        handleDeleteSkill={handleDeleteSkill}
                        handleAddSkill={handleAddSkill}
                        awardArray={awardArray}
                        handleAwardChange={handleAwardChange}
                        handleDeleteAward={handleDeleteAward}
                        handleAddAward={handleAddAward}
                        publications={publications}
                        handlePubChange={handlePubChange}
                        handleDeletePublication={handleDeletePublication}
                        handleAddPublication={handleAddPublication}
                        languages={languages}
                        handleLangChange={handleLangChange}
                        languageStore={languageStore}
                        langLevelsArray={langLevelsArray}
                        handleDeleteLang={handleDeleteLang}
                        handleAddLang={handleAddLang}
                        interests={interests}
                        setInterestsArray={setInterestsArray}
                        handleInterestChange={handleInterestChange}
                        handleDeleteInterests={handleDeleteInterests}
                        handleAddInterests={handleAddInterests}
                        basicInfoForward={basicInfoForward}
                        eduInfoForwardOrBackward={eduInfoForwardOrBackward}
                        workExpForwardOrBackward={workExpForwardOrBackward}
                        skillsForwardOrBackward={skillsForwardOrBackward}
                        certsForwardOrBackward={certsForwardOrBackward}
                        pubForwardOrBackward={pubForwardOrBackward}
                        langForwardOrBackward={langForwardOrBackward}
                        interestsBackward={interestsBackward}
                        existingResumes={existingResumes}
                        existingResumeSelectedIndex={existingResumeSelectedIndex}
                        onExistingResumeSelect={onExistingResumeSelect}
                        onExistingResumePreview={onExistingResumePreview}
                        storedResumeSelected={storedResumeSelected}
                        selectedStoredResumeName={selectedStoredResumeName}
                    />
                )}



            </DataContainerStyled>
        </div>

    )
}

export default DataContainer;